import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import AddtionalSupplyChainForm from '@EUForms/addtionalSupplyChainForm'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { useDispatch, useSelector } from 'react-redux'
import { partiesInfo } from '../../util/partiesLabel'

const AddtionalSupplyChainDetail = ({
  dataSource,
  supplyChainOwnerList,
  onBlur, 
  onSelect,
  isImportShipment,
  ...rest
}) => {

  const dispatch = useDispatch()
  const getData = (selectedOwner, callback) => (dispatch, getState) => {
    if (!selectedOwner) {
      callback('')
      return
    }
    const identification =
      getState().actorReducer[
        partiesInfo(isImportShipment)[selectedOwner?.toLowerCase()]?.tableName]?.[0]?.eoriNo || ''
    callback(identification)
  }
  
  const onOwnerChange = (params) => {
    return (e, { value, name }) => {
      const { dataSource, onSelect, tableName } = params
      const callback = (identification) => {
        onSelect(dataSource.id, tableName, {
          [name]: value,
          id: dataSource.id,
          role: dataSource.role,
          eoriNo:identification,
        })
      }
      dispatch(getData(value, callback))
    }
  }

  const renderAtLast = useCallback(
    (params) => {
      const { dataSource, disableFields, isDisabled } = params

      return (
        <Grid.Column>
          <DropDown
            id={`owner${dataSource.id}`}
            label='owner'
            labelClass='text-none'
            clearable
            name='owner'
            isDisabled={disableFields|| isDisabled}
            data={supplyChainOwnerList}
            value={dataSource.owner}
            text={dataSource.owner}
            onChange={onOwnerChange(params)}
          />
        </Grid.Column>
      )
    },
    [supplyChainOwnerList]
  )
  const renderItem = useCallback(
    (item) => {
      const onBlurHandler = (tableName, payload) => onBlur(tableName, payload) 
      const onSelectHandler = (id, tableName, params, name) => onSelect(id, tableName, params)
      return (
      <AddtionalSupplyChainForm
        dataSource={item}
        key={item.id}
        onBlur={onBlurHandler}
        onSelect={onSelectHandler}
        renderAtLast={renderAtLast}
        {...rest}
      />
    )
  },
    [renderAtLast, rest]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(AddtionalSupplyChainDetail)
